import { usePaginatedList } from '@core/hooks/usePaginatedList';
import { churchListService } from '../services/churchSvc';
import { ChurchQueryParams, ChurchMeta, Church } from '../types/church';

interface UseChurchesResult {
  churches: Church[];
  loading: boolean;
  error: string | null;
  pagination: ChurchMeta | null;
  refetch: () => void;
  updateParams: (newParams: Partial<ChurchQueryParams>) => void;
  validationErrors: string[];
}

export const useChurches = (initialParams: ChurchQueryParams = {}): UseChurchesResult => {
  const { items, ...rest } = usePaginatedList<Church, ChurchQueryParams, ChurchMeta>(
    churchListService,
    initialParams,
    {
      filterResetFields: ['freetext', 'churchName', 'districtId', 'districtName'],
      normalizeKeys: ['freetext', 'churchName', 'districtName'],
      entityLabel: 'churches',
    }
  );

  return { churches: items, ...rest };
};
